import { InitOverviewController } from "@sabyr-dev/mist_core/controller";
import { OverviewScore } from "@sabyr-dev/mist_core/model/datasource/score";
import {
	Attempt, Product, Question, Quiz
} from "@sabyr-dev/mist_elibrary/datasource";
import { AcademyApp } from "../app";
import { AcademyAttemptTableRecord } from "../model/datasource";

export class AcademyInitOverviewController extends InitOverviewController<Product, Attempt, Quiz, Question> {
	async init(app: AcademyApp): Promise<void> {
		app.view.init(app);
		await app.model.metadata.revertToLocalCookie();
		await app.model.score.restoreAttempts();
		const [product, scores, attempts]: [
			Product, OverviewScore<Attempt, Quiz>[], AcademyAttemptTableRecord[]
		] = await Promise.all([
			app.model.metadata.getProductId(),
			app.model.score.getOverviewScores(),
			app.model.score.getAttempts(),
		]);
		const summary = app.view.chart.getOverviewSummaryTable(app.getJquery());
		app.view.summary.displayTable(summary, product);
		summary.populate(summary.getTable(app.view.summary.frontend.getTable()), attempts);
		app.view.sections.displayOverviewScores(
			app.view.chart.getOverviewScoreChart(),
			scores
		);
		app.view.sections.displayHighScores(scores);
	}
}
